// Import global sass.
// > import sub sass files inside main.scss
import './assets/sass/main.scss';

import {createApp} from 'vue';
import App from './App.vue';
import router from './router/router';

//global variables
import config from './config';

import ComponentRepo from './services/ComponentRepo';
import AppInitializer from './services/AppInitializer';
import DataAdapter from './services/DataAdapter';
import CreateSiteManifestLoader from './services/FetchSiteManifest';
import store from './store/store';

import ApiManager from './services/api/ApiManager';

// app data in global space
window.app = {
    manifest: false,
    api: {},
    config
}


// Various API functions bundled
ApiManager(app)

// Load manifest to create pseudo pages
const manifestLoader = CreateSiteManifestLoader({
    MANIFEST_PATH: config.manifest,
    FETCH_OPTIONS: {
        mode: "cors",
        headers: {
            "Accept-language": 'en'
        }
    },
    DataDecorator: (manifest) => {
        return DataAdapter(manifest)
    }
})

// Load manifest into global object for fast and easy access
window.app.manifest = manifestLoader;


// Init app
const vm = createApp(App).use(store);
ComponentRepo.setup(vm)
vm.use(store)
vm.use(router);
vm.mount('#app');




AppInitializer()
    // Add steps here to run during load of SPA
    .addStep({
        id: 'data-load',
        tasks: [{
            id: 'fetch-manifest',
            execute: () => manifestLoader.fetchData()
        }]
    })
    .start(() => {
    })
    // addStep() methods are run here!
    .then(() => {
        //Check if page exists or redirect to HomePage
        if (!window.app.manifest.pageExists(window.app.vm.$route.path)) {
            
            //TODO:
            //Navigate til noget error 404 handling i stedet for homepage
            window.app.manifest.navigateToHomePage().then(() => {
                store.commit('ready')
            })
        } else {
            store.commit('ready')
        }
    }
)